import api from "../security/api";

const fciAlta = (client, instance, uri, currencyId, itemPropertyId, depositoryId, request) => {
    return api
        .post(`fci/${uri}/alta?client=${client}&instance=${instance}&currencyId=${currencyId}&itemPropertyId=${itemPropertyId}&depositoryId=${depositoryId}`, request);
};

const fciIngresar = (client, instance, uri, nroId) => {
    return api
        .put(`fci/${uri}/${nroId}/ingresar?client=${client}&instance=${instance}`);
};

const fciConsulta = (client, instance, uri, nroId) => {
    return api
        .get(`fci/${uri}/${nroId}?client=${client}&instance=${instance}`);
};

const fciEliminar = (client, instance, uri, nroId) => {
    return api
        .delete(`fci/${uri}/${nroId}/eliminar?client=${client}&instance=${instance}`);
};

const fciAnular = (client, instance, uri, nroId) => {
    return api
        .put(`fci/${uri}/${nroId}/anular?client=${client}&instance=${instance}`);
};

const fciAltaComitente = (client, instance, uri, nroId, request) => {
    return api
        .post(`fci/${uri}/${nroId}/comitentes/altaComitente?client=${client}&instance=${instance}`, request);
};

const fciConsultaComitente = (client, instance, uri, nroId) => {
    return api
        .get(`fci/${uri}/${nroId}/comitentes?client=${client}&instance=${instance}`);
};

const fci = {
    fciAlta,
    fciIngresar,
    fciConsulta,
    fciEliminar,
    fciAnular,
    fciAltaComitente,
    fciConsultaComitente
}

export default fci;